import React from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { orange } from '@material-ui/core/colors';

const theme = createMuiTheme({
    palette: {
        primary: orange,
    },
});

export default function StTextField(props) {
    return (
        <ThemeProvider theme={theme}>
            <TextField
                style={props.style}
                defaultValue={props.defaultValue}
                value={props.value}
                id={props.id}
                label={props.label}
                variant="outlined"
                onChange={(event) => { props.onChange(event.target.value) }}
                type={props.type}
            />
        </ThemeProvider>
    )
}